import React from "react";
/**
 * 
 * @param {any} props
 */
const ButtonConfirmador = (props) => {
    /**/
    return <div className="custom-icono">
        <a className="clickable none-text-decoration icon-confirmador222" aria-hidden="true"></a>
    </div>;
}

export default ButtonConfirmador;